Vue.component('ack-comparison-cards-section', {
	delimiters: ['${', '}$'],
	template: '#ack-comparison-cards-section',
	props: {
		isVisible: {
			type: Boolean,
			required: false,
			default: true,
		},
		title: {
			type: String,
			required: false,
			default: '',
		},
		sectionData: {
			type: Object,
			required: true,
		},
		sectionClass: {
			type: String,
			required: false,
			default: '',
		},
		titleClass: {
			type: String,
			required: false,
			default: '',
		},
	},
	computed: {
		displayTitle() {
			return this.title || this.sectionData?.title || '';
		},
	},
});
